import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react"
import { DatePicker, Flex, Input, Select, Typography } from "antd"
import React, { useState } from "react"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  addAbonement,
  getAbonementTypes,
} from "src/store/Slices/AbonementsSlice"
import { getAbonementsList } from "src/store/Slices/ClientsSlice"
import { openNotification } from "src/components/helpers/notification"

const AddNewAbonement = ({ visible, setVisible }) => {
  // HELPERS
  const dispatch = useDispatch()

  // STATE
  const [name, setName] = useState()
  const [code, setCode] = useState()
  const [type, setType] = useState()
  const [isBuyable, setIsBuyable] = useState(false)
  const [startingTime, setStartingTime] = useState()
  const [endingTime, setEndingTime] = useState()

  const abonemetsTypes = useSelector(
    (state) => state.AbonementsSlice.abonemetsTypes,
  )

  const abonementsList = useSelector(
    (state) => state.AbonementsSlice.abonementsList,
  )

  const isBuyOptions = [
    { value: true, label: "Да" },
    { value: false, label: "Нет" },
  ]

  useEffect(() => {
    dispatch(getAbonementTypes())
  }, [])

  const onClickAddAbonement = () => {
    dispatch(
      addAbonement({
        name: name,
        code: code,
        typeId: type,
        isBuyable: isBuyable,
        startingTime: startingTime,
        endingTime: endingTime,
      }),
    ).then(() => {
      dispatch(getAbonementsList())
      setVisible(false)
    })
  }

  return (
    <CModal
      alignment='center'
      visible={visible}
      aria-labelledby='VerticallyCenteredExample'
      onClose={() => {
        setVisible(false)
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id='VerticallyCenteredExample'>
          {"Добавить абонемент"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Наименование</Typography.Title>
              <Input
                defaultValue=''
                value={name}
                onChange={(e) => setName(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>Код изображения</Typography.Title>
              <Input
                defaultValue=''
                value={code}
                onChange={(e) => setCode(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>Тип</Typography.Title>
              <Select
                style={{ width: "100%" }}
                options={abonemetsTypes?.data?.value}
                onChange={(value) => {
                  setType(value)
                }}
                placeholder={"Выбрать"}
                value={type}
              />
            </div>

            <div>
              <Typography.Title level={5}>Доступен</Typography.Title>
              <Select
                style={{ width: "100%" }}
                value={isBuyable}
                onChange={(e) => setIsBuyable(e)}
                options={isBuyOptions}
              />
            </div>

            {((abonementsList?.name === "DAILY") || (abonementsList?.name === "NIGHTLY")) && (
              <div>
                <Typography.Title level={5}>От</Typography.Title>
                <DatePicker 
                  onChange={(date, dateString) => setStartingTime(dateString)}
                />
              </div>
            )}

            {((abonementsList?.name === "DAILY") || (abonementsList?.name === "NIGHTLY")) && (
              <div>
                <Typography.Title level={5}>До</Typography.Title>
                <DatePicker 
                  onChange={(date, dateString) => setEndingTime(dateString)}
                />
              </div>
            )}
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setVisible(false)
          }}
          style={{ color: "#fff" }}
          color='secondary'
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickAddAbonement} style={{ color: "#fff" }}>
          Добавить
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default AddNewAbonement
